import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { IconButton } from '@/components/ui/button';
import { SlidersHorizontal } from 'lucide-react';
import { FilterPatients } from '@patientMenu/form/FilterPatients.tsx';
import usePatientStore from '@patientMenu/hooks/usePatientStore.ts';
import { cn } from '@/lib/utils';

export function PatientFiltersPopover() {
  const { query } = usePatientStore();
  const hasActiveFilters = Boolean(query.status ?? query.scanDateFrom ?? query.scanDateTo);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <IconButton
          variant="ghost-light"
          size="icon"
          icon={SlidersHorizontal}
          aria-label="Filter patients"
          className={cn(hasActiveFilters && 'border-primary/35 bg-primary/10 text-primary-300')}
        />
      </PopoverTrigger>
      <PopoverContent className="w-80 p-4" align="end">
        <p className="mb-3 text-[10px] font-semibold uppercase tracking-[0.14em] text-white/45">Filters</p>
        <FilterPatients compact />
      </PopoverContent>
    </Popover>
  );
}
